export * from "./related-blog";
export * from "./detail";
